export default {
  relics: '遗物',
  museum: '博物馆',
  battery: '圣遗物电池',
  glyph: {
    title: '雕文: {0}',
    noLevel: '在基座上添加一个带有此雕文的圣遗物来提高此雕文的等级',
    speedOvercap: '您分配的雕文比需要升级的雕文更多，这使得该雕文升级的速度加快了x{0}',
    speedBonus: '你有来自其他基座的{0}奖励雕文，提高升级速度x{1}',
    dust: '灰尘',
    clay: '粘土',
    heat: '热量',
    wood: '木头',
    flow: '流动',
    stone: '石头',
    spike: '尖刺',
    dream: '梦',
    clover: '三叶草',
    rain: '雨',
    sun: '日',
    cloud: '云',
    blossom: '绽放',
    leaf: '叶子',
    paper: '纸',
    book: '书',
    coin: '硬币',
    card: '卡牌',
  },
  pedestal: {
    modify: '改装基座',
    modifyDescription: '更改任何基座都会重置所有雕文的当前等级进度，因此在进行任何更改之前请仔细考虑',
    unsavedChanges: '在点击"{0}"确认之前，对基座的更改不会生效',
  },

  torch: {
    name: '火炬',
    active: '照明',
    description: '移除深度限制',
    formula: '选择深度。在剩余的时间里，只要达到最小深度，盐和矿石在这个深度就可以获得（增益50%）',
  },
  purpleHeart: {name: '紫心勋章'},
  dustyBook: {name: '布满灰尘的书'},
  rottenLeaf: {name: '腐烂的叶子'},
  stonepiercer: {
    name: '石头穿孔机',
    active: '粉碎',
    description: '在所有地方应用最大的破坏',
    formula: '对于每个深度，取下面所有深度的最高休息量。通过这样做（{0}）从断点获得硝石',
  },
  consolationPrize: {name: '安慰奖'},
  prettyLamp: {name: '漂亮的灯'},
  museumKey: {name: '博物馆钥匙'},
  ribbon: {name: '丝带'},
  copier: {name: '复印机'},
  deckOfCards: {name: '游戏牌'},
  chessboard: {name: '棋盘'},
  iridiscentFlower: {name: '彩虹花'},
  scienceBook: {name: '科学书'},
  hugeDiamond: {name: '巨大钻石'},

  excavator: {name: '挖掘机'},
  redCard: {name: '红牌'},
  briefcase: {name: '公文包'},
  strangePlant: {name: '奇怪的植物'},
  beneficialVirus: {name: '有益的病毒'},
  shapeCollection: {
    name: '形状收集',
    active: 'AI艺术',
    description: '自动收集 {0} 形状',
    formula: '花费 {0} 动机 (最多 {1}) 去自动收集 {2} 形状. 这不会改变当前的形状网格'
  },
  stonePillar: {name: '石柱'},
  fieryRuby: {name: '火红的红宝石'},

  notebook: {
    name: '笔记本',
    active: '抄作业',
    description: '获得 {0} 总点数',
    formula: '提高你的总点数 {0}, 或者通过考试获得 {1} 总点数代替 (仅限常规任务)'
  },

  friendlyBat: {
    name: '友好的蝙蝠',
    active: '回声定位',
    description: '立即收到 {0} 废料',
    formula: '基于拥有的最高废料数量 ({0}) 和 20分钟的最深完成深度（{1}）废料收入',
  },
  honeyPot: {
    name: '蜂蜜罐',
    active: '蜂群',
    description: '充分填充您的树脂',
    formula: '获得等于你的树脂容量({0})的树脂',
  },

  mudBrick: {name: '泥砖'},
  sapling: {name: '树苗'},
  keychain: {
    name: '钥匙链',
    active: '税收征收',
    description: '立即获得 {0} 金币',
    formula: '基于拥有的最高金币数量 ({0}) 和最高粮食产量 ({1}) 的10分钟税收',
  },
  screwdriver: {name: '螺丝刀'},

  energyDrink: {
    name: '能量饮料',
    active: '精力充沛',
    description: '刷新战斗活动',
    formula: '重置所有战斗活动的冷却时间 ({0}) 并重新开始当前的战斗'
  },

  lightningRod: {
    name: '避雷针',
    active: '雷暴',
    description: '最大治疗加成',
    formula: '消耗 {0} 雨水 ({1}% 需要手动的东西) 去最大化所有治疗加成',
  },
  goldenCarrot: {name: '金胡萝卜'},
  goldenApple: {name: '金苹果'},
  popcorn: {name: '爆米花'},
  roseQuartz: {name: '玫瑰石英'},
  goldenSeed: {name: '金种子'},

  lightbulb: {name: '灯泡'},
  fishbowl: {name: '鱼缸'},
  pencil: {name: '铅笔'},
  smallBrush: {
    name: '小刷子',
    active: '绘制特殊形状',
    description: '创建一个随机的特殊形状',
  },
  strangePills: {name: '奇怪的药丸'},
  printingPress: {name: '印刷机'},

  diamondPickaxe: {name: '钻石镐'},
  diamondHammer: {name: '钻石锤'},
  diamondSword: {name: '钻石剑'},
  diamondShovel: {name: '钻石铲'},
  diamondBrush: {name: '钻石刷子'},
  diamondPillar: {name: '钻石柱子'},

  tinfoilHat: {name: '锡箔帽子'},
  cupOfWater: {name: '一杯水'},
  combatStrategy: {name: '战斗策略'},
  hundredDollarBill: {name: '100美元钞票'},
  hotAirBalloon: {name: '热气球'},
  largeClover: {name: '大三叶草'},
  eightBall: {name: '8号球'},
  youngPig: {name: '幼猪'},
  silverHorseshoe: {name: '银马蹄铁'},
  bronzeTools: {name: '青铜工具'},
  minersHat: {name: '矿工帽'},
  dictionary: {name: '字典'},
  expertTools: {name: '专家工具'},
  bloodBag: {name: '血袋'},
  geode: {name: '晶洞'},
  birthdayCake: {name: '生日蛋糕'},
  colorfulFlower: {name: '七彩花'},
  heatingBulb: {name: '加热灯泡'},
  trashCan: {name: '垃圾桶'},
  suitcase: {name: '手提箱'},
  tropicalTent: {name: '热带帐篷'},
  fruitBasket: {name: '水果篮'},
  massiveGrain: {name: '大量谷物'},
  enchantedBottle: {name: '附魔瓶'},
  moneyGift: {name: '金钱礼物'},
  frozenCarrot: {name: '冻胡萝卜'},
};
